var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activity
    ? _c(
        "div",
        [
          _c("validation-observer", {
            ref: "form",
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var handleSubmit = ref.handleSubmit
                    return [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return handleSubmit(_vm.onSubmit)
                            },
                          },
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { outlined: "" } },
                            [
                              _vm.activity.id
                                ? _c("v-card-title", [
                                    _vm._v(
                                      "Editing " +
                                        _vm._s(_vm.translate(_vm.activity.name))
                                    ),
                                  ])
                                : _c("v-card-title", [
                                    _vm._v("Creating new activity"),
                                  ]),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c("m-field", {
                                            attrs: { m: "activity", a: "code" },
                                            model: {
                                              value: _vm.activity.code,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.activity,
                                                  "code",
                                                  $$v
                                                )
                                              },
                                              expression: "activity.code",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c("m-field", {
                                            attrs: {
                                              m: "activity",
                                              a: "sector_id",
                                              component: "v-select",
                                              items: _vm.sectors,
                                              "item-value": "id",
                                              "item-text":
                                                "name." + _vm.$i18n.locale,
                                            },
                                            model: {
                                              value: _vm.activity.sector_id,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.activity,
                                                  "sector_id",
                                                  $$v
                                                )
                                              },
                                              expression: "activity.sector_id",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("m-field", {
                                    attrs: {
                                      m: "activity",
                                      a: "name",
                                      i18n: "",
                                    },
                                    model: {
                                      value: _vm.activity.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.activity, "name", $$v)
                                      },
                                      expression: "activity.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        type: "submit",
                                        text: "",
                                        color: "primary",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("actions.save")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2464685659
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }